import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import "../../styles/dashboard/dashboard.css";
import Header from "../../components/header/Header";
import InfoCard from "../../components/cards/InfoCard";
import "../../styles/cards/card.css";
import AddNewSiteCard from "../../components/cards/AddNewSiteCard";
import { Icon } from "@iconify/react/dist/iconify.js";
import AddScannedBook from "../../components/cards/AddScannedBook";
import Modal from "../../components/modal/Modal";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import axios from "axios";
import Pagination from "../../components/pagination/Pagination";
import Cookies from "js-cookie";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InitializeSite from "../../components/cards/InitializeSite";
import { debounce } from "lodash";

const SupervisorDashboard = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [sites, setSites] = useState([]);
  const [loadingSites, setLoadingSites] = useState(true);
  const [loadingCards, setLoadingCards] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const entriesPerPage = 10;
  const [scannedStats, setScannedStats] = useState({
    totalScanned: 0,
    totalBooks: 0,
    totalApprovedBooks: 0,
    totalDeclined: 0,
    totalApproved: 0,
  });
  const [yellowFormStats, setYellowFormStats] = useState({
    totalScannedForms: 0,
    totalForms: 0,
    totalApprovedForms: 0,
    totalDeclined: 0,
    totalApproved: 0,
  });
  const [refreshSites, setRefreshSites] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  })

  useEffect(() => {
    const fetchScannedStats = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(
          `${baseUrl}/api/scanned/scanned-records/stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setScannedStats(res.data);
      } catch (error) {
        setError("Failed to load site data");
      } finally {
        setLoadingCards(false);
      }
    };
    const fetchScannedSites = async () => {
      setLoadingSites(true);
          try {
            const token = Cookies.get("token");
            const endpoint =`${baseUrl}/api/sites/active`;
            const res = await axios.get(endpoint, {
              headers: { Authorization: `Bearer ${token}` },
            });
            console.log(res, "fetchScannedSites");
            
            setSites(res.data);
          } catch (err) {
            setError("Failed to load latest scanned sites");
          } finally {
            setLoadingSites(false);
          }
        };

    fetchScannedSites();
    fetchScannedStats();
  }, [baseUrl]);

  useEffect(() => {
    const fetchScannedYellowFormStats = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(
          `${baseUrl}/api/yellow-forms/stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setYellowFormStats(res.data);
      } catch (error) {
        setError("Failed to load site data");
      } finally {
        setLoadingCards(false);
      }
    };
    fetchScannedYellowFormStats();
  }, [baseUrl]);


  // useEffect(() => {
  //   const fetchSites = async (
  //   ) => {
  //     try {
  //       setLoadingSites(true);
  //       const token = Cookies.get("token");
  //       const res = await axios.get(`${baseUrl}/api/sites/scanner-operator/sites`, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  //       setSites(res.data);

  //     } catch (error) {
  //       console.error("Error fetching sites:", error);
  //       setSites([]);
  //       setError("Failed to load site data");
  //     } finally {
  //       setLoadingSites(false);
  //     }
  //   };

  //   fetchSites();
  // }, [baseUrl, refreshSites]);

  const debouncedSearch = useCallback(
    debounce((term) => {
      setDebouncedSearchTerm(term);
      setCurrentPage(1);
    }, 500),
    []
  );
  const filteredSites = sites.filter((site) => {
  if (!debouncedSearchTerm) return true; // Show all if no search term
  
  const searchLower = debouncedSearchTerm.toLowerCase();
  return (
    site.sector?.toLowerCase().includes(searchLower) ||
    site.district?.toLowerCase().includes(searchLower)
  );
});

  const handleSiteAdded = (newSite) => {
    setSites((prevSites) => [...prevSites, newSite]);
    setRefreshSites(prev => !prev);
  };

  const handleModalClose = () => {
    setRefreshSites((prev) => !prev);
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    debouncedSearch(term);
  };

  const renderSkeletonCards = () => {
    return Array(3)
      .fill()
      .map((_, index) => (
        <div key={index} className="card" style={{ minWidth: "300px" }}>
          <div className="card-header">
            <Skeleton width={250} height={12} />
            <Skeleton width={60} height={40} />
          </div>
          <div className="line"></div>
          <div className="card-content">
            <div className="progress-bar-container">
              <Skeleton width="100%" height={10} />
              <Skeleton width={80} height={12} style={{ marginTop: "11px" }} />
            </div>
          </div>
        </div>
      ));
  };

  const renderSkeletonSites = () => {
    return Array(4)
      .fill()
      .map((_, index) => (
        <div
          key={index}
          className="new-site-container scanned-books-card indexed skeleton-card"
          style={{ backgroundColor: "transparent" }}
        >
          <div className="sector-info">
            <Skeleton width={150} height={20} />
            <Skeleton width={60} height={12} style={{ marginTop: "8px" }} />
          </div>
          <div className="add-button">
            <Skeleton width={180} height={40} borderRadius={43} />
          </div>
        </div>
      ));
  };

  const fetchDetailedStats = () =>
    axios.get(`${baseUrl}/api/scanned/scanned-records/stats/details/scanner`, {
      headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    });

  const fetchDetailedYellowFormStats = () => {
    return axios.get(
      `${baseUrl}/api/yellow-forms/stats/details/scanner`,
      {
        headers: { Authorization: `Bearer ${Cookies.get("token")}` },
      }
    );
  }

  return (
    <>
      <div className="dashboard-container">
        <Sidebar role="coordinator" />
        <div className="main-content">
          <Header />
          <div className="dashboard-content">
            {/* <div className="dashboard-cards">
              {loadingCards ? (
                renderSkeletonCards()
              ) : (
                <>
                  <InfoCard
                    value={`${scannedStats?.totalApproved}/${scannedStats?.totalScanned}`}
                    title="OVERALL SCANNED RECORDS"
                    progress={
                      (scannedStats?.totalApproved / scannedStats?.totalScanned) *
                      100
                    }
                    fetchDetails={fetchDetailedStats}
                  />
                  <InfoCard
                    value={`${scannedStats?.totalApprovedBooks}/${scannedStats?.totalBooks}`}
                    title="OVERALL SCANNED BOOKS"
                    progress={
                      (scannedStats?.totalApprovedBooks / scannedStats?.totalBooks) * 100
                    }
                    fetchDetails={fetchDetailedStats}
                  />
                  <InfoCard
                    value={`${yellowFormStats?.totalApproved}/${yellowFormStats?.totalScannedForms}`}
                    title="OVERALL SCANNED YELLOW FORMS"
                    progress={
                      (yellowFormStats?.totalApproved / yellowFormStats?.totalScannedForms) *
                      100
                    }
                    fetchDetails={fetchDetailedYellowFormStats}
                  />
                  <InfoCard
                    value={`${scannedStats?.totalDeclined}/${scannedStats?.totalScanned}`}
                    title="DECLINED SCANNED RECORDS"
                    progress={
                      scannedStats?.totalScanned > 0
                        ? (scannedStats?.totalDeclined /
                            scannedStats?.totalScanned) *
                          100
                        : 0
                    }
                    fetchDetails={fetchDetailedStats}
                  />
                </>
              )}
            </div> */}

            <div className="scanned-books-container">
              <div className="search-container">
                <div className="search">
                  <div className="search-icon">
                    <Icon
                      icon="proicons:search"
                      color="#078ECE"
                      width="16"
                      height="16"
                    />
                  </div>
                  <input
                    type="text"
                    placeholder="Search sector or district "
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <div className="scanned-books-cards">
                {/* <AddNewSiteCard onSiteAdded={handleSiteAdded}/> */}

                {loadingSites
                  ? renderSkeletonSites()
                  : sites.length > 0 && (
                      <>
                        {filteredSites
                          .filter((site) => site.status === "NON_ACTIVE")
                          .map((site) => (
                            <InitializeSite
                              key={site.id}
                              siteId={site.id}
                              sector={site.sector}
                              province={site.province}
                              district={site.district}
                              onModalClose={handleModalClose}
                            />
                          ))}
                        {filteredSites
                          .filter((site) => site.status !== "NON_ACTIVE")
                          .map((site) => (
                            <AddScannedBook
                              key={site.id}
                              siteId={site.id}
                              sector={site.sector}
                              district={site.district}
                            />
                          ))}
                      </>
                    )}
              </div>
              {pagination.totalItems > 0 && (
                <Pagination
                  currentPage={pagination.currentPage}
                  totalItems={pagination.totalItems}
                  entriesPerPage={entriesPerPage}
                  onPageChange={setCurrentPage}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupervisorDashboard;
